import { Box, Flex, HStack, Text } from '@chakra-ui/react';
interface TotalContractCardProps {
  title: string;
  icon: { element: JSX.Element; color: string };
  children?: React.ReactNode;
  selected?: boolean;
  onClickCard?: () => void;
}
const TotalContractCard = ({
  title,
  icon,
  children,
  selected,
  onClickCard = () => {},
}: TotalContractCardProps) => {
  return (
    <Box
      p="3"
      border="1px solid"
      borderColor={selected ? 'yPrimary.500' : 'yGray.100'}
      width="100%"
      borderRadius="6px"
      cursor="pointer"
      onClick={onClickCard}
    >
      <HStack justify="space-between" w="100%">
        <Flex align="center">
          <Text variant="regular" color="yGray.500">
            {title}
          </Text>
        </Flex>
        <Flex
          bg={icon.color + '.100'}
          color={icon.color + '.600'}
          align="center"
          justify="center"
          h="32px"
          w="32px"
          borderRadius="100px"
        >
          {icon.element}
        </Flex>
      </HStack>
      <Text>{children}</Text>
    </Box>
  );
};
export default TotalContractCard;
